import {
  CLEAR_CITY_BIKES,
  GET_CITY_BIKES
} from '../constants/cityBikes';
import {
  createReducer,
  createRequestReducer,
  defaultListInitialState
} from '../utils';

const initialState = defaultListInitialState();

const cityBikes = createReducer(initialState, {
  [GET_CITY_BIKES]: (state, action) => createRequestReducer(state, action, {
    SEND: (state, action) => ({
      ...initialState,
      isFetching: true,
      query: action.meta.queryParams
    }),

    SUCCESS: (state, action) => ({
      ...initialState,
      items: action.response.results
    }),

    FAIL: (state, action) => ({
      ...initialState,
      error: action.error
    })
  }),

  [CLEAR_CITY_BIKES]: () => ({ ...initialState })
});

export default cityBikes;



// WEBPACK FOOTER //
// ./src/reducers/cityBikes.js